import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
// import Typography from '@mui/material/Typography'
import { Formik } from 'formik'
import React, { useCallback, useState } from 'react'
import * as Yup from 'yup'

import { RequestType } from '..'
import { Event as EventApi, FormEvent as FormEventApi } from '../../../../API'
import FormComponent from '../../../../components/forms/elements/Form'
import FormButton from '../../../../components/forms/elements/FormButton'
import FormButtonContainer from '../../../../components/forms/elements/FormButtonContainer'
import FormGrid from '../../../../components/forms/elements/FormGrid'
import content from '../form/content'
import manualContent from '../form/manualContent'
import schema from '../form/schema'

interface Props {
  events: Array<Event | FormEvent>
  onSubmit: (values: Yup.InferType<typeof schema>, type: RequestType) => void
  loading: boolean
}

type Event = Omit<Exclude<EventApi, null>, '__typename'>
type FormEvent = Omit<Exclude<FormEventApi, null>, '__typename'>

const Form: React.FC<Props> = ({ events, onSubmit, loading }) => {
  const [formLoading, setFormLoading] = useState(false)
  const [showEnterID, setShowEnterId] = useState(false)

  const handleSubmit = useCallback(
    async (values: Yup.InferType<typeof schema>) => {
      setFormLoading(true)
      onSubmit(values, RequestType.DOWNLOAD)
      setFormLoading(false)
    },
    [onSubmit],
  )

  const handleShowSummary = useCallback(
    async (values: Yup.InferType<typeof schema>, type) => {
      setFormLoading(true)
      onSubmit(values, type)
      setFormLoading(false)
    },
    [onSubmit],
  )

  const handleSelection = useCallback(() => {
    setShowEnterId(!showEnterID)
  }, [showEnterID])

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'end' }}>
        <Button
          variant="text"
          color="info"
          onClick={handleSelection}
          size="small"
          sx={{ mb: 2 }}>
          {showEnterID
            ? 'Click here to select from list'
            : 'Click here to manually enter event ID'}
        </Button>
      </Box>
      {events && !showEnterID && (
        <Formik
          initialValues={{
            eventId: null,
          }}
          validateOnMount={true}
          enableReinitialize
          validationSchema={schema}
          onSubmit={handleSubmit}>
          {(form) => {
            return (
              <FormComponent>
                <Card>
                  <FormGrid
                    content={content({
                      formDisabled: form.isSubmitting || formLoading,
                      events,
                    })}
                  />
                </Card>
                <FormButtonContainer wrap={false}>
                  <Box gap={1} display="flex" flexDirection="row">
                    <FormButton
                      secondary
                      outlined
                      disabled={!form.isValid || form.isSubmitting || loading}
                      loading={loading}
                      onClick={() =>
                        handleShowSummary(
                          form.values,
                          RequestType.SHOW_PARTICIPANT_SUMMARY,
                        )
                      }>
                      Participant Count
                    </FormButton>
                    <FormButton
                      secondary
                      outlined
                      disabled={!form.isValid || form.isSubmitting || loading}
                      loading={loading}
                      onClick={() =>
                        handleShowSummary(
                          form.values,
                          RequestType.SHOW_SHIRT_SUMMARY,
                        )
                      }>
                      Shirt Count
                    </FormButton>
                  </Box>
                  <FormButton
                    submit
                    primary
                    outlined
                    disabled={!form.isValid || form.isSubmitting || loading}
                    loading={loading}>
                    Download
                  </FormButton>
                </FormButtonContainer>
              </FormComponent>
            )
          }}
        </Formik>
      )}
      {showEnterID && (
        <Formik
          initialValues={{
            eventId: null,
          }}
          validateOnMount={true}
          enableReinitialize
          validationSchema={schema}
          onSubmit={handleSubmit}>
          {(form) => {
            return (
              <FormComponent>
                <Card>
                  <FormGrid
                    content={manualContent({
                      formDisabled: form.isSubmitting || formLoading,
                    })}
                  />
                </Card>
                <FormButtonContainer wrap={false}>
                  <></>
                  <FormButton
                    submit
                    primary
                    outlined
                    disabled={!form.isValid || form.isSubmitting || loading}
                    loading={loading}>
                    Download
                  </FormButton>
                </FormButtonContainer>
              </FormComponent>
            )
          }}
        </Formik>
      )}
    </>
  )
}

export default Form
